import { useSelector } from 'react-redux'
import { StateExtended } from '../../_config/interfaces/stateExtended'
import { KEYS } from '../../_config'


export function useAuthStatus() {
  const isAuthenticated = useSelector((state: StateExtended) => state.user.isAuthenticated)
  // Check localStorage instead of sessionStorage for cross-tab authentication
  const hasAccessToken = localStorage.getItem(KEYS.AUTH_ACCESS)
  const hasRefreshToken = localStorage.getItem(KEYS.AUTH_REFRESH)
  
  // User is authenticated if they have tokens in localStorage and Redux state says they're authenticated
  if(!hasAccessToken || !hasRefreshToken){
    return false
  }
  return isAuthenticated
}
export function useUserSelector() {
  const user = useSelector((state: StateExtended) => state.user.user)
  return user
}
